import MaterialButton from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';

export const positionEnum = {
  left: 'left',
  center: 'center',
  right: 'right',
};

const TextButton = ({ onClick, disabled, type, children, position, className, style, ...materialProps }) => (
  <div className={className} style={{ textAlign: position }}>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <MaterialButton {...materialProps} onClick={onClick} disabled={disabled} type={type} style={style}>
      {children}
    </MaterialButton>
  </div>
);

TextButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  position: PropTypes.oneOf(Object.values(positionEnum)),
  type: PropTypes.string,
  style: PropTypes.shape(),
};

TextButton.defaultProps = {
  className: undefined,
  disabled: false,
  onClick: () => undefined,
  position: positionEnum.left,
  type: 'button',
  style: undefined,
};

export default React.memo(TextButton);
